import React, { useState, useEffect } from "react";
import {
  Typography,
  Paper,
  Box,
  Modal,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstant from "../../../api";
import toast from "react-hot-toast";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  shortlistId: number | null;
  fetchShortlists: () => void;
  apiBase?: string;
  label?: string;
}

export default function DeleteShortlistModal({
  open,
  setOpen,
  shortlistId,
  fetchShortlists,
  apiBase = '/shortlists',
  label = 'Shortlist',
}: Props) {
  const [loading, setLoading] = useState(false);

  const handleDeleteShortlist = async () => {
    setLoading(true);
    try {
      await axiosInstant.delete(`${apiBase}/${shortlistId}`);
      setOpen(false);
      fetchShortlists();
      toast.success(`${label} deleted successfully!`);
    } catch (error) {
      toast.error("Error deleting shortlist");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        component={Paper}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: 'calc(100% - 24px)', sm: 400 },
          maxWidth: 400,
          bgcolor: "var(--surface)",
          borderRadius: "12px",
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          padding: { xs: '16px', sm: '24px' },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontSize: { xs: 20, sm: 24 }, fontWeight: 900 }}>
            Delete {label}
          </Typography>

          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography
          sx={{
            color: "var(--Base-900, #444)",
            fontFamily: "CircularStd",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 450,
            lineHeight: "normal",
          }}
        >
          Are you sure you want to delete this {label.toLowerCase()}?
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            onClick={handleDeleteShortlist}
            variant="contained"
            color="primary"
            sx={{ ml: 2 }}
            disabled={loading}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
